// extracted by mini-css-extract-plugin
export default {"workshopsHeading":"Workshops_workshopsHeading__zFaQg","workshopsIntro":"Workshops_workshopsIntro__vcf6V"};